// Coming Soon / Wartungsseite mit verstecktem Admin-Login
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LogIn, Loader2, Eye, EyeOff } from "lucide-react";
import logoImage from "@/assets/logo-optimized.webp";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
const ComingSoon = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const {
        data,
        error
      } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      if (error) {
        toast.error("Anmeldung fehlgeschlagen", {
          description: error.message
        });
        return;
      }
      if (data.session) {
        toast.success("Erfolgreich angemeldet!");
        navigate("/");
      }
    } catch (err) {
      toast.error("Ein Fehler ist aufgetreten");
    } finally {
      setIsLoading(false);
    }
  };
  return <main className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5 flex flex-col">
      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center space-y-8 max-w-2xl">
          {/* Logo */}
          <div className="flex justify-center">
            <img src={logoImage} alt="SpeisekartenCheck Logo" className="w-32 h-32 object-contain" width={128} height={128} loading="eager" fetchPriority="high" decoding="async" />
          </div>

          {/* Title */}
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground">SpeisekartenCheck.de</h1>
            <div className="h-1 w-24 bg-primary mx-auto rounded-full" />
          </div>

          {/* Message */}
          <div className="space-y-4">
            <p className="text-xl md:text-2xl text-muted-foreground">
              Diese Seite befindet sich im Aufbau.
            </p>
            <p className="text-lg text-muted-foreground/80">
              Sie können gespannt sein! 🚀
            </p>
          </div>

          {/* Decorative elements */}
          
        </div>
      </div>

      {/* Login Section - Bottom Right */}
      <div className="fixed bottom-6 right-6">
        {!showLogin ? <Button variant="outline" size="sm" onClick={() => setShowLogin(true)} className="gap-2 bg-background/80 backdrop-blur-sm border-border/50 hover:border-primary/50">
            <LogIn className="h-4 w-4" />
            Admin-Login

          </Button> : <Card className="w-80 shadow-lg border-border/50 bg-background/95 backdrop-blur-sm">
            <CardHeader className="pb-4">
              <CardTitle className="text-lg flex items-center justify-between">
                Anmelden
                <Button variant="ghost" size="sm" onClick={() => setShowLogin(false)} className="h-6 w-6 p-0 text-muted-foreground hover:text-foreground">
                  ×
                </Button>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleLogin} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email"></Label>
                  <Input id="email" type="email" placeholder="ihre@email.de" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="password">Passwort</Label>
                  <div className="relative">
                    <Input id="password" type={showPassword ? "text" : "password"} placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
                    <Button type="button" variant="ghost" size="sm" className="absolute right-0 top-0 h-full px-3 hover:bg-transparent" onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <EyeOff className="h-4 w-4 text-muted-foreground" /> : <Eye className="h-4 w-4 text-muted-foreground" />}
                    </Button>
                  </div>
                </div>
                <Button type="submit" className="w-full" disabled={isLoading}>
                  {isLoading ? <>
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      Adminlogin...
                    </> : <>
                      <LogIn className="mr-2 h-4 w-4" />
                      Adminlogin
                    </>}
                </Button>
              </form>
            </CardContent>
          </Card>}
      </div>
    </main>;
};
export default ComingSoon;